import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api',
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const auth = {
    login: async (email: string, password: string) => {
        console.log('Making login request to API with email:', email);
        const response = await api.post('/users/login', { email, password });
        console.log('Login API response:', response.data);
        if (response.data.access_token) {
            console.log('Access token received, storing in localStorage');
            localStorage.setItem('token', response.data.access_token);
        } else {
            console.warn('No access token received in login response');
        }
        return response.data;
    },
    signup: async (username: string, password: string, name: string) => {
        const response = await api.post('/users/register', { username, password, name });
        return response.data;
    },
    logout: () => {
        localStorage.removeItem('token');
    },
};

export default api; 